import { CSSProperties } from 'react';
import { SvgImage } from 'components/images/SvgImage';
import { Logo } from 'greener-ui-library';

type ProjectLogoProps = {
  projectLogoUrl?: string;
  projectName: string;
  organisationLogoUrl?: string;
  style?: CSSProperties;
};

export default function ProjectLogo({ projectLogoUrl, projectName, organisationLogoUrl, style }: ProjectLogoProps) {
  const representativeCharacter = projectName?.charAt(0) ?? '-';
  const logoUrl = projectLogoUrl || organisationLogoUrl;

  return (
    <Logo
      logoUrl={logoUrl}
      width="100%"
      height={projectLogoUrl ? 'auto' : undefined}
      representativeChar={representativeCharacter}
      svgImage={logoUrl ? <SvgImage logoUrl={logoUrl} /> : undefined}
      sx={{
        minHeight: 104, // 0.5 * (240 - 16*2) = 104
        maxHeight: 188, // 0.9 * (240 - 16*2) = 187.2
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        ...style,
      }}
    />
  );
}
